export default __webpack_public_path__ + "static/media/bpsc-crack-img.3eef9d80.png";